import React from 'react';

export const FAQ1 = () => {
    return (
        <>
            <p className="mb-4">Help to Habit helps you build strong leadership habits in 30 days.</p>
            <ul style={{paddingLeft: '1.5rem'}}>
                <li className="mb-2"><span className="font-bold">Text Messages:</span>Daily tips and reminders sent to your phone. Standard rates for text message may apply.</li>
                <li><span className="font-bold">Email Recap:</span>Weekly recap emails will keep you motivated to apply the behavior.</li>
            </ul>
        </>
    );
};
export const FAQ2 = () => {
    return (
        <>
            <p className="mb-4">Help to Habit helps you build strong leadership habits in 30 days.</p>
            <ul style={{paddingLeft: '1.5rem'}}>
                <li className="mb-2"><span className="font-bold">Text Messages:</span>Daily tips and reminders sent to your phone. Standard rates for text message may apply.</li>
                <li><span className="font-bold">Email Recap:</span>Weekly recap emails will keep you motivated to apply the behavior.</li>
            </ul>
        </>
    );
};

export const FAQ3 = () => {
    return (
        <>
            <p className="mb-4">Help to Habit helps you build strong leadership habits in 30 days.</p>
            <ul style={{paddingLeft: '1.5rem'}}>
                <li className="mb-2"><span className="font-bold">Text Messages:</span>Daily tips and reminders sent to your phone. Standard rates for text message may apply.</li>
                <li><span className="font-bold">Email Recap:</span>Weekly recap emails will keep you motivated to apply the behavior.</li>
            </ul>
        </>
    );
};